module.exports = __webpack_public_path__ + "img/icon_ahorro.52d42b9a.svg";